import { render, staticRenderFns } from "./EventDetailPage.vue?vue&type=template&id=642e1450&scoped=true"
import script from "./EventDetailPage.vue?vue&type=script&lang=js"
export * from "./EventDetailPage.vue?vue&type=script&lang=js"
import style0 from "./EventDetailPage.vue?vue&type=style&index=0&id=642e1450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e1450",
  null
  
)

export default component.exports